"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FindJobClickSearchSuccessEvent = exports.FindJobResultsClickViewDetailsSuccessEvent = exports.FindJobResultsClickBookmarkSuccessEvent = exports.FindJobResultsClickPleaseSubmitSuccessEvent = exports.FindJobResultsChooseSortSuccessEvent = exports.FindJobResultsRecommendJobsSuccessEvent = exports.FindJobResultsLandingSuccessEvent = exports.FindJobInputJobIdSuccessEvent = exports.FindJobInputWageMinSuccessEvent = exports.FindJobDragRadiusSuccessEvent = exports.FindJobInputCitySuccessEvent = exports.FindJobChooseStateSuccessEvent = exports.FindJobChooseSpecialtySuccessEvent = exports.FindJobChooseDisciplineSuccessEvent = exports.FindJobClickViewDetailsSuccessEvent = exports.FindJobClickBookmarkSuccessEvent = exports.FindJobClickPleaseSubmitSuccessEvent = exports.FindJobRecommendJobsSuccessEvent = exports.FindJobLandingSuccessEvent = void 0;
const base_event_1 = require("./base.event");
class FindJobLandingSuccessEvent extends base_event_1.BaseEvent {
    constructor() {
        super(...arguments);
        this.type = 'FIND_JOB_LANDING_SUCCESS';
    }
}
exports.FindJobLandingSuccessEvent = FindJobLandingSuccessEvent;
class FindJobRecommendJobsSuccessEvent extends base_event_1.BaseEvent {
    constructor() {
        super(...arguments);
        this.type = 'FIND_JOB_RECOMMEND_JOBS_SUCCESS';
    }
}
exports.FindJobRecommendJobsSuccessEvent = FindJobRecommendJobsSuccessEvent;
class FindJobClickPleaseSubmitSuccessEvent extends base_event_1.BaseEvent {
    constructor() {
        super(...arguments);
        this.type = 'FIND_JOB_CLICK_PLEASE_SUBMIT_SUCCESS';
    }
}
exports.FindJobClickPleaseSubmitSuccessEvent = FindJobClickPleaseSubmitSuccessEvent;
class FindJobClickBookmarkSuccessEvent extends base_event_1.BaseEvent {
    constructor() {
        super(...arguments);
        this.type = 'FIND_JOB_CLICK_BOOKMARK_SUCCESS';
    }
}
exports.FindJobClickBookmarkSuccessEvent = FindJobClickBookmarkSuccessEvent;
class FindJobClickViewDetailsSuccessEvent extends base_event_1.BaseEvent {
    constructor() {
        super(...arguments);
        this.type = 'FIND_JOB_CLICK_VIEW_DETAILS_SUCCESS';
    }
}
exports.FindJobClickViewDetailsSuccessEvent = FindJobClickViewDetailsSuccessEvent;
class FindJobChooseDisciplineSuccessEvent extends base_event_1.BaseEvent {
    constructor() {
        super(...arguments);
        this.type = 'FIND_JOB_CHOOSE_DISCIPLINE_SUCCESS';
    }
}
exports.FindJobChooseDisciplineSuccessEvent = FindJobChooseDisciplineSuccessEvent;
class FindJobChooseSpecialtySuccessEvent extends base_event_1.BaseEvent {
    constructor() {
        super(...arguments);
        this.type = 'FIND_JOB_CHOOSE_SPECIALTY_SUCCESS';
    }
}
exports.FindJobChooseSpecialtySuccessEvent = FindJobChooseSpecialtySuccessEvent;
class FindJobChooseStateSuccessEvent extends base_event_1.BaseEvent {
    constructor() {
        super(...arguments);
        this.type = 'FIND_JOB_CHOOSE_STATE_SUCCESS';
    }
}
exports.FindJobChooseStateSuccessEvent = FindJobChooseStateSuccessEvent;
class FindJobInputCitySuccessEvent extends base_event_1.BaseEvent {
    constructor() {
        super(...arguments);
        this.type = 'FIND_JOB_INPUT_CITY_SUCCESS';
    }
}
exports.FindJobInputCitySuccessEvent = FindJobInputCitySuccessEvent;
class FindJobDragRadiusSuccessEvent extends base_event_1.BaseEvent {
    constructor() {
        super(...arguments);
        this.type = 'FIND_JOB_DRAG_RADIUS_SUCCESS';
    }
}
exports.FindJobDragRadiusSuccessEvent = FindJobDragRadiusSuccessEvent;
class FindJobInputWageMinSuccessEvent extends base_event_1.BaseEvent {
    constructor() {
        super(...arguments);
        this.type = 'FIND_JOB_INPUT_WAGE_MIN_SUCCESS';
    }
}
exports.FindJobInputWageMinSuccessEvent = FindJobInputWageMinSuccessEvent;
class FindJobInputJobIdSuccessEvent extends base_event_1.BaseEvent {
    constructor() {
        super(...arguments);
        this.type = 'FIND_JOB_INPUT_JOB_ID_SUCCESS';
    }
}
exports.FindJobInputJobIdSuccessEvent = FindJobInputJobIdSuccessEvent;
class FindJobResultsLandingSuccessEvent extends base_event_1.BaseEvent {
    constructor() {
        super(...arguments);
        this.type = 'FIND_JOB_RESULTS_LANDING_SUCCESS';
    }
}
exports.FindJobResultsLandingSuccessEvent = FindJobResultsLandingSuccessEvent;
class FindJobResultsRecommendJobsSuccessEvent extends base_event_1.BaseEvent {
    constructor() {
        super(...arguments);
        this.type = 'FIND_JOB_RESULTS_RECOMMEND_JOBS_SUCCESS';
    }
}
exports.FindJobResultsRecommendJobsSuccessEvent = FindJobResultsRecommendJobsSuccessEvent;
class FindJobResultsChooseSortSuccessEvent extends base_event_1.BaseEvent {
    constructor() {
        super(...arguments);
        this.type = 'FIND_JOB_RESULTS_CHOOSE_SORT_SUCCESS';
    }
}
exports.FindJobResultsChooseSortSuccessEvent = FindJobResultsChooseSortSuccessEvent;
class FindJobResultsClickPleaseSubmitSuccessEvent extends base_event_1.BaseEvent {
    constructor() {
        super(...arguments);
        this.type = 'FIND_JOB_RESULTS_CLICK_PLEASE_SUBMIT_SUCCESS';
    }
}
exports.FindJobResultsClickPleaseSubmitSuccessEvent = FindJobResultsClickPleaseSubmitSuccessEvent;
class FindJobResultsClickBookmarkSuccessEvent extends base_event_1.BaseEvent {
    constructor() {
        super(...arguments);
        this.type = 'FIND_JOB_RESULTS_CLICK_BOOKMARK_SUCCESS';
    }
}
exports.FindJobResultsClickBookmarkSuccessEvent = FindJobResultsClickBookmarkSuccessEvent;
class FindJobResultsClickViewDetailsSuccessEvent extends base_event_1.BaseEvent {
    constructor() {
        super(...arguments);
        this.type = 'FIND_JOB_RESULTS_CLICK_VIEW_DETAILS_SUCCESS';
    }
}
exports.FindJobResultsClickViewDetailsSuccessEvent = FindJobResultsClickViewDetailsSuccessEvent;
class FindJobClickSearchSuccessEvent extends base_event_1.BaseEvent {
    constructor() {
        super(...arguments);
        this.type = 'FIND_JOB_CLICK_SEARCH_SUCCESS';
    }
}
exports.FindJobClickSearchSuccessEvent = FindJobClickSearchSuccessEvent;
//# sourceMappingURL=find-job.events.js.map